var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Hours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f00000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7 48.8H34c2.6-2.7 5.6-6.5 5.6-10.4s-2.6-6.3-6.3-6.3c-3.5 0-6.3 2.8-6.3 6.3 0 1 .8 1.9 1.9 1.9 1 0 1.9-.8 1.9-1.9 0-1.4 1.1-2.5 2.5-2.4 2.5 0 2.5 1.9 2.5 2.5 0 4-5.8 9.1-8 10.8-.8.6-1 1.9-.3 2.7.3.5.9.7 1.5.7h8.8c1 0 1.9-.8 1.9-1.9s-1-1.9-2-2zM53 32.1c-1 0-1.9.8-1.9 1.9v16.7c0 1 .8 1.9 1.9 1.9s1.9-.8 1.9-1.9V34c0-1-.8-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 40.5h-9.3V34c.1-1-.7-2-1.8-2-1-.1-2 .7-2 1.8v8.6c0 1 .8 1.9 1.9 1.9h11.2c1 0 1.9-.8 1.9-1.9.1-1-.8-1.9-1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4 25c-.3-.6-1-.9-1.6-.6-.6.3-.9 1-.6 1.6 8.7 19.5-.5 42.1-20.5 50.5-16.4 6.8-35.5 2.2-46.7-11.3l4.8 1.7c.6.2 1.3-.1 1.6-.7.3-.6-.1-1.3-.7-1.6h-.1L8 61.5c-.6-.2-1.3.1-1.6.7-.1.2-.1.4-.1.6l1.2 10c.1.6.6 1 1.2 1h.2c.7-.1 1.1-.6 1.1-1.3L9.2 67c14.7 17.5 41.3 20.1 59.2 5.9C83.2 61.4 88 41.8 80.4 25zM79.2 20.6l-1-10c-.1-.7-.7-1.2-1.3-1.1-.6 0-1.1.6-1.1 1.2v.1l.6 5.6C61.5-1.3 34.8-4.1 16.6 10.2 1.9 21.7-3.1 41.3 4.2 58.2c.3.6 1 .9 1.6.6.6-.3.9-1 .6-1.6-8.6-19.7.7-42.5 21-50.9C44-.6 63.3 4.3 74.5 18.1l-4.8-1.8c-.6-.3-1.4 0-1.7.6-.3.6 0 1.3.6 1.6h.1l8.7 3.3c.1 0 .3.1.4.1.7 0 1.3-.5 1.3-1.2.2 0 .2 0 .1-.1z",
    stroke: "#f00000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 6.7c-.7 0-1.2.5-1.3 1.2v5.4c0 .7.5 1.3 1.1 1.3s1.3-.5 1.3-1.1V7.9c.1-.7-.5-1.2-1.1-1.2zM42.5 70.4c-.7 0-1.3.5-1.3 1.3V77c0 .7.6 1.2 1.3 1.2.6 0 1.1-.5 1.2-1.2v-5.3c0-.7-.5-1.3-1.2-1.3zM77 41.2h-5.3c-.7-.1-1.3.4-1.4 1.1-.1.7.4 1.3 1.1 1.4H77c.7 0 1.3-.5 1.3-1.1 0-.7-.5-1.3-1.1-1.3-.1-.1-.1-.1-.2-.1zM13.3 41.2H7.9c-.7-.1-1.3.3-1.5 1-.1.6.3 1.3.9 1.4h5.9c.7 0 1.2-.6 1.2-1.3 0-.5-.5-1.1-1.1-1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Hours);
export default __webpack_public_path__ + "static/media/24-hours.4bf95fb820f89ba15772cc716f01f6a3.svg";
export { ForwardRef as ReactComponent };